import { useState, useEffect } from 'react';

const navItems = [
  { label: '追漫体验', href: '#features' },
  { label: '热门推荐', href: '#cards' },
  { label: '人气榜单', href: '#ranking' },
  { label: '编辑精选', href: '#media' },
  { label: '更新快讯', href: '#updates' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/60' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-[72px]">
        <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="font-heading text-2xl font-bold text-primary-500 whitespace-nowrap cursor-pointer">
          YY漫画
        </a>

        <nav className="hidden md:flex items-center gap-1">
          <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-lg whitespace-nowrap cursor-pointer">
            首页
          </a>
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-lg whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
          <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="ml-3 px-5 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            开始追漫
          </a>
        </nav>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 px-4 py-4 flex flex-col gap-1">
          <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg whitespace-nowrap cursor-pointer">
            首页
          </a>
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
          <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="mt-2 px-5 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full text-center hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            开始追漫
          </a>
        </div>
      )}
    </header>
  );
}